module.exports = __webpack_public_path__ + "static/media/nestje7.79ccede8.webp";